import Typo from '@/components/Typography/Typo';

export const FieldBadge = ({ type }: { type: string }) => {
  return (
    <div className="h-4 px-1 rounded border border-gray-400 inline-flex justify-center items-center gap-1">
      <Typo type="label5" className="text-gray-700" weight="m">
        {type}
      </Typo>
    </div>
  );
};
